import React, { useMemo } from 'react'
import { PopoverHover } from "components/Popover";
import UnitsLocations from "pages/Legacy/Order/365Plus/UnitsLocations";
import { CategoryContainer, CategoryContainerHasHover } from "pages/Legacy/Order/365Plus/Category/style";

const Order365Category = ({ value, row, noUsed }: any) => {

    const categoryStr = useMemo(() => { // Secured, Tagged, and Risk
        const arr = []
        // if (row.original?.isSecured && row.original?.isUnsecured) return 'S & U'
        // if (row.original?.isSecured) arr.push('Secured')
        // if (row.original?.isUnsecured) arr.push('Unsecured')
        const tagCount = row.original?.ebayCount + row.original?.fbModelCount + row.original?.fbMpnCount
        if (row.original?.isSecured || tagCount > 0) {
            if (row.original?.isSecured) arr.push('Sec')
            if (tagCount > 0) arr.push('Tag')
        }
        else if (row.original?.riskQuantity > 0) arr.push('Risk')
        return arr.join(' & ')
    }, [row])


    const [isUnitLocation, caQuantity, blueStarQty] = useMemo(() => [
        row.original?.isSecured || row.original?.riskQuantity > 0 || row.original?.ebayCount > 0 || row.original?.fbModelCount > 0 || row.original?.fbMpnCount > 0,
        row.original?.caQuantity,
        row.original?.blueStarQty
    ], [row])


    if (!isUnitLocation || !categoryStr) {

        if (caQuantity || blueStarQty) {
            return (
                <PopoverHover Component={<UnitsLocations row={row} noUsed={noUsed} />}>
                    <CategoryContainer isHovered>
                        <CategoryContainerHasHover />
                        {categoryStr}
                    </CategoryContainer>
                </PopoverHover>
            )
        }

        return (
            <CategoryContainer>
                {categoryStr}
            </CategoryContainer>
        )
    }


    return (
        <PopoverHover Component={<UnitsLocations row={row} noUsed={noUsed} />}>
            <CategoryContainer isHovered>
                <CategoryContainerHasHover />
                {categoryStr}
            </CategoryContainer>
        </PopoverHover>
    )
}


export default Order365Category
